// extracted by mini-css-extract-plugin
export default {"hoverImg":"ImageOverlay_hoverImg__Yie6X","figcaption":"ImageOverlay_figcaption__zUtmd"};